import { render } from "./hunterSidebar.vue?vue&type=template&id=65327910"
import script from "./hunterSidebar.vue?vue&type=script&lang=js"
export * from "./hunterSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__